import { useId, useState, type ReactNode } from "react";
import "./infoTip.scss";

type Props = {
  text: ReactNode;
  /** Names the thing being explained, for the button's accessible label. */
  label?: string;
  /** Flip the bubble to hang off the right edge when the tip sits near one. */
  align?: "left" | "right";
  /** Open upwards where the tip sits in a bar pinned to the bottom of the window,
      which would otherwise put the bubble below the fold. */
  placement?: "below" | "above";
};

export function InfoTip({ text, label, align = "left", placement = "below" }: Props) {
  const [open, setOpen] = useState(false);
  const tipId = useId();

  if (!text) return null;

  return (
    <span
      className="info-tip"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        type="button"
        className="info-tip__btn"
        aria-label={label ? `About ${label}` : "More info"}
        aria-describedby={open ? tipId : undefined}
        aria-expanded={open}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        onClick={() => setOpen((prev) => !prev)}
      >
        i
      </button>
      {open && (
        <span
          id={tipId}
          role="tooltip"
          className={`info-tip__bubble info-tip__bubble--${align} info-tip__bubble--${placement}`}
        >
          {text}
        </span>
      )}
    </span>
  );
}

export default InfoTip;
